import { notAvailable } from 'core/common/constants';
import { normalizeError } from 'core/common/errors';
import { AppThunk } from 'core/common/store';

export const updateEmailConsentRequest =
  (value: boolean): AppThunk =>
  async (dispatch, _, context) => {
    const { loggingService, userService, errorMonitoringService } = context;

    try {
      await userService.update({ settings: { email_consent: value } });
    } catch (e) {
      const err = normalizeError(e);
      loggingService.error(err);

      errorMonitoringService.captureError(err, {
        tags: {
          email_consent: value,
          get_params: location.search || notAvailable,
          error_message: err.message,
          error_reason: 'update_email_consent',
        },
      });
    }
  };
